import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { LobbyWaitingContainer } = await import('./index');
    return {
        Component: LobbyWaitingContainer,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
